<div class="ac-variants-coverages-table">
    <div *ngFor="let rowItem of shortComparisonConfig" class="ac-variants-coverages-table__row">
        <div class="coverage__title">
            <app-ac-variants-coverages-row-title
                    [title]="getCoverageLabel(rowItem.coverageName) | translate"
                    [tooltip]="rowItem.tooltip"
            ></app-ac-variants-coverages-row-title>
        </div>

        <ng-container class="coverage__values">
            <ng-container *ngFor="let variant of variantsOrder">
                <app-ac-variants-coverages-row-value *ngIf="hasVariant(variant)"
                                                     [value]="getVariantValue(variant, rowItem)"
                ></app-ac-variants-coverages-row-value>
            </ng-container>
        </ng-container>
    </div>
</div>

